import { render, staticRenderFns } from "./SuccessMessageSideBar.vue?vue&type=template&id=3f0ca025&scoped=true&"
import script from "./SuccessMessageSideBar.vue?vue&type=script&lang=js&"
export * from "./SuccessMessageSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ca025",
  null
  
)

export default component.exports